import { Checkbox, FormControlLabel } from "@material-ui/core";
import LoadingComponent from "../LoadingComponent";
import FSelect, { Item } from "./FSelect";

interface Props {
  name: string;
  label: string;
  required: boolean;
  items: Item[] | undefined;
  allProjectsAndSubjects: boolean;
  onAllProjectsAndSubjectsChanged: ((value: boolean) => void) | undefined;
  isLoadingProjectsAndSubjects: boolean;
  autoFocus?: boolean;
  useSearchField?: boolean | undefined;
  onValueChanged?: ((value: unknown) => void) | undefined;
  onAddButtonClick?: (() => void) | undefined;  
}


export default function FProjectsAndSubjectsSDTOSelect(props: Props) {
  return (
    <FSelect
      name={props.name}
      label={props.label}
      required={props.required}
      items={props.items}
      autoFocus={props.autoFocus}
      useSearchField={props.useSearchField}
      onValueChanged={props.onValueChanged}
      onAddButtonClick={props.onAddButtonClick}
      extraControl={
        props.onAllProjectsAndSubjectsChanged !== undefined ?
        props.isLoadingProjectsAndSubjects
        ?
          <LoadingComponent useBackdrop={false}/>
        :
        <FormControlLabel
          control={
          <Checkbox
            name={"checkboxAllProjectsAndSubjects"}
            checked={props.allProjectsAndSubjects}
            onChange={(_event, checked) => props.onAllProjectsAndSubjectsChanged!(checked)}
            onClick={(event) => {
              event.preventDefault();
              event.stopPropagation();
            }}
          />
        }
        label='Alle projecten / onderwerpen'
      />
       :
       undefined
      }
    />
  );
}
